import { atom } from 'recoil';

export const workflowBreakpointsState = atom<string[]>({
  key: 'workflowBreakpoints',
  default: [],
});
